import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f92ada14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-notify toast-container position-fixed top-0 start-50 translate-middle-x" }
const _hoisted_2 = { class: "toast-body" }

import { ref } from 'vue'
import { Toast } from 'bootstrap'
import { SiteNotifyEventArgs } from './SiteNotifyEvent'


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteNotify',
  setup(__props, { expose: __expose }) {

const messageRef = ref('')
const actionTextRef = ref('')

let onAction: (() => void) | undefined

const toastRef = ref<HTMLElement>();

__expose({
  show,
})

function show(options: SiteNotifyEventArgs) {
  messageRef.value = options.message
  actionTextRef.value = options.actionText || ''
  onAction = options.onAction

  if (toastRef.value) {
    const toast = Toast.getOrCreateInstance(toastRef.value, { delay: options.timeout || 5000, autohide: true })
    toast.show()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "toastRef",
      ref: toastRef,
      class: "toast",
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(messageRef.value), 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onAction) && _unref(onAction)(...args)))
          }, "Action")
        ])
      ])
    ], 512)
  ]))
}
}

})